import api from './data.services'
import { authService } from './'

const examsSrv = 'exams/procedures'
const examFileSrv = 'exams/procedures/views/files'
const relationshipTypeSrv = 'types/relationships/exams'
const examShareSrv = 'exams/procedures/sends/exams'

const getExams = async (patientId?: string, page: number = 1, limit: number = 5) => {
  try {
    let url = `${examsSrv}${patientId ? '/' + patientId : ''}`
    
    if (page !== undefined && limit !== undefined) {
      const params = new URLSearchParams()
      params.append('page', page.toString())
      params.append('limit', limit.toString())
      url += `?${params.toString()}`
    }
    
    const resp: any = await api.get(url, authService.getToken())

    if (resp?.data?.laboratories && typeof resp.data.laboratories === 'object' && resp.data.laboratories.data) {
      return {
        status: 'Ok',
        data: resp.data.laboratories
      }
    }
    
    return {
      status: 'Ok',
      data: (resp?.data?.laboratories ? resp.data.laboratories : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al examenes de laboratorio!'
    }
  }
}

const getRelationshipType = async () => {
  try {
    const resp: any = await api.get(relationshipTypeSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp?.data?.typeRelationship ? resp.data.typeRelationship : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener tipos de relaciones!'
    }
  }
}

const getExamFile = async (examId: string, patientId: string, patientType: string) => {
  try {
    const user = authService.getUserCurrentInfoStorage()
    const resp: any = await api.get(`${examFileSrv}${'/' + (patientId ? patientId : user.id)}${'/' + examId}${'/' + patientType}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp?.data?.url_file ? resp.data.url_file : '')
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al ver examen médico!'
    }
  }
}

const postExamShare = async (data: any, examId: string, patientId: string, patientType: string) => {
  try {
    const user = authService.getUserCurrentInfoStorage()
    const resp: any = await api.post(`${examShareSrv}${'/' + (patientId ? patientId : user.id)}${'/' + examId}${'/' + patientType}`, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al compartir examen médico!'
    }
  }
}

export const examService = {
  getExams,
  getExamFile,
  getRelationshipType,
  postExamShare
}